const verses = {
    "pt": {
        "nervous": [
            {
                "text": "Tudo posso naquele que me fortalece.",
                "reference": "Filipenses 4:13",
                "message": "Sua força não está em você, mas em uma fonte inabalável. Avance com coragem, você é capaz de enfrentar isso!"
            },
            {
                "text": "O Senhor é a minha luz e a minha salvação; de quem terei medo? O Senhor é o meu forte refúgio; de quem terei medo?",
                "reference": "Salmos 27:1",
                "message": "Não deixe o medo paralisar você. Sua proteção é absoluta e inabalável. Olhe para a frente, a luz está com você."
            },
            {
                "text": "Lança o teu pão sobre as águas, porque depois de muitos dias o acharás.",
                "reference": "Eclesiastes 11:1",
                "message": "Cada ato de bondade ou esforço que você faz retornará. Continue plantando sementes de fé e generosidade, os frutos virão."
            },
            {
                "text": "Mas os que esperam no Senhor renovarão as suas forças; subirão com asas como águias; correrão, e não se cansarão; caminharão, e não se fatigarão.",
                "reference": "Isaías 40:31",
                "message": "A força que você precisa está na espera. A renovação virá como asas de águia. Corra, caminhe e nunca mais desanime."
            },
            {
                "text": "No amor não há medo; antes o perfeito amor lança fora o medo.",
                "reference": "1 João 4:18",
                "message": "O amor é o antídoto para o medo. Mergulhe no amor perfeito. Ele expulsará toda a sua insegurança e pavor."
            },
            {
                "text": "E não nos cansemos de fazer o bem, pois no tempo próprio colheremos, se não desanimarmos.",
                "reference": "Gálatas 6:9",
                "message": "Não desista de fazer o bem. A recompensa virá no tempo certo. Mantenha-se firme na sua missão, sua colheita é certa."
            },
            {
                "text": "A fé é a certeza daquilo que esperamos e a prova das coisas que não vemos.",
                "reference": "Hebreus 11:1",
                "message": "Sua fé é a base sólida para o que você ainda não pode ver. Não duvide. Mantenha a firmeza, a prova virá."
            },
            {
                "text": "Sujeitai-vos, pois, a Deus, resisti ao Diabo, e ele fugirá de vós.",
                "reference": "Tiago 4:7",
                "message": "A sua força está na submissão ao Superior. Resista firmemente ao mal. Sua obediência é a arma que faz o mal fugir."
            },
            {
                "text": "A tua palavra é lâmpada para os meus pés e luz para o meu caminho.",
                "reference": "Salmos 119:105",
                "message": "A Palavra é o seu mapa e guia. Ela ilumina cada passo e todo o seu percurso. Confie na luz para seguir em frente."
            },
            {
                "text": "Mas o Senhor é fiel; ele vos confirmará e guardará do maligno.",
                "reference": "2 Tessalonicenses 3:3",
                "message": "Sua segurança está na fidelidade do Altíssimo. Ele irá protegê-lo de todo o mal. Permaneça firme e confie em Sua guarda."
            },
            {
                "text": "Porque Deus não nos deu o espírito de temor, mas de fortaleza, e de amor, e de moderação.",
                "reference": "2 Timóteo 1:7",
                "message": "Seu espírito não é de medo, mas de força. Você é cheio de amor e autocontrole. Rejeite a intimidação e aja com poder."
            },
            {
                "text": "Aquele que murmura é infiel no pouco, no muito também é infiel.",
                "reference": "Lucas 16:10",
                "message": "A fidelidade nos pequenos detalhes constrói a confiança. Seja responsável com o que lhe é dado. Isso o prepara para o maior."
            },
            {
                "text": "O homem de coração sábio aceitará os mandamentos, mas o que é tolo de lábios será transtornado.",
                "reference": "Provérbios 10:8",
                "message": "Aja com sensatez e aceite a instrução. A teimosia e a tolice levam à ruína. Escolha o caminho da sabedoria."
            },
            {
                "text": "Ainda que eu andasse pelo vale da sombra da morte, não temeria mal algum, porque tu estás comigo; a tua vara e o teu cajado me consolam.",
                "reference": "Salmos 23:4",
                "message": "Mesmo nos momentos mais sombrios, você não está sozinho. Sua proteção e consolo estão sempre presentes para guiá-lo.        "
            },
            {
                "text": "O Senhor te guardará de todo o mal; guardará a tua alma.",
                "reference": "Salmos 121:7",
                "message": "Não se preocupe com o mal ao redor. Há uma guarda constante sobre sua vida. Sua alma está segura e protegida."
            },
            {
                "text": "O justo passa por muitas adversidades, mas o Senhor o livra de todas.",
                "reference": "Salmos 34:19",
                "message": "As lutas virão, mas a libertação é certa. Mantenha a integridade. Você será resgatado de toda a sua dor."
            },
            {
                "text": "Sonda-me, ó Deus, e conhece o meu coração; prova-me, e conhece os meus pensamentos.",
                "reference": "Salmos 139:23",
                "message": "Permita que sua mente e coração sejam examinados. A verdade, embora inquietante, traz clareza e um caminho seguro."
            },
            {
                "text": "Visto que a carne é fraca, mas o espírito é pronto.",
                "reference": "Mateus 26:41",
                "message": "Sua vontade é forte, mesmo quando seu corpo falha. Reze e vigie para que seu espírito o guie e fortaleça."
            },
            {
                "text": "Mas nós não somos daqueles que recuam para a perdição, senão daqueles que creem para a conservação da alma.",
                "reference": "Hebreus 10:39",
                "message": "Não recue. Sua fé o levará adiante. Mantenha-se firme na crença para proteger sua vida e seu futuro."
            },
            {
                "text": "Vós tendes por pai o Diabo, e quereis satisfazer os desejos de vosso pai.",
                "reference": "João 8:44",
                "message": "Cuidado com as influências. Escolha a sua filiação. Resista ao mal e siga o caminho da verdade e da luz."
            },
            {
                "text": "Ora, sem fé é impossível agradar-lhe; porque é necessário que aquele que se aproxima de Deus creia que ele existe, e que é galardoador dos que o buscam.",
                "reference": "Hebreus 11:6",
                "message": "Dê o primeiro passo com fé. A crença é o que move tudo. Confie que você será recompensado por sua busca sincera."
            },
            {
                "text": "Não se aparte da tua boca o livro desta lei; antes medita nele dia e noite, para que tenhas cuidado de fazer conforme a tudo quanto nele está escrito; porque então farás prosperar o teu caminho, e serás bem-sucedido.",
                "reference": "Josué 1:8",
                "message": "A prosperidade é resultado da meditação e obediência. Estude a Palavra constantemente. Sua jornada será bem-sucedida."
            },
            {
                "text": "Não ameis o mundo, nem o que no mundo há. Se alguém ama o mundo, o amor do Pai não está nele.",
                "reference": "1 João 2:15",
                "message": "Cuidado com onde você deposita seu afeto. O amor pelas coisas mundanas traz conflito. Escolha o amor que dura para sempre."
            },
            {
                "text": "Ora, a fé é a certeza de coisas que se esperam, a convicção de fatos que se não veem.",
                "reference": "Hebreus 11:1",
                "message": "Sua certeza não depende de evidências visíveis. A fé é sua convicção. Mantenha a firmeza no que está por vir."
            },
            {
                "text": "Portanto, vede prudentemente como andais, não como néscios, mas como sábios.",
                "reference": "Efésios 5:15",
                "message": "Pense bem em seus passos. A sabedoria está na cautela. Ande com discernimento, evite a tolice e o erro."
            },
            {
                "text": "No muito falar não falta transgressão, mas o que modera os seus lábios é prudente.",
                "reference": "Provérbios 10:19",
                "message": "Pense antes de falar. A moderação das palavras evita erros e conflitos. A prudência é sua melhor aliada."
            },
            {
                "text": "O que anda em integridade anda seguro, mas o que perverte os seus caminhos será descoberto.",
                "reference": "Provérbios 10:9",
                "message": "A honestidade é sua proteção. O caminho íntegro garante segurança. Desvie-se da falsidade para evitar a queda."
            },
            {
                "text": "Não vos prendais a um jugo desigual com os infiéis; porque que sociedade tem a justiça com a injustiça? E que comunhão tem a luz com as trevas?",
                "reference": "2 Coríntios 6:14",
                "message": "Cuidado com as companhias. Alinhe-se com quem compartilha seus valores. A disparidade de propósitos pode ser perigosa."
            },
            {
                "text": "Aquele que furtava, não furte mais; antes trabalhe, fazendo com as mãos o que é bom, para que tenha o que repartir com o que tem necessidade.",
                "reference": "Efésios 4:28",
                "message": "Mude seu caminho e use suas mãos para o bem. O trabalho honesto traz dignidade. Você será capaz de ajudar outros.    "
            },
            {
                "text": "O Senhor é bom, uma fortaleza no dia da angústia; e conhece os que confiam nele.",
                "reference": "Naum 1:7",
                "message": "Sua segurança é um refúgio. Ele é bom e forte, conhece seu coração. Confie Nele para protegê-lo em tempos difíceis."
            },
            {
                "text": "O temor do Senhor conduz à vida; e aquele que o tem ficará satisfeito, e não o visitará mal nenhum.",
                "reference": "Provérbios 19:23",
                "message": "A reverência e o respeito pela Palavra trazem segurança e satisfação. Você viverá em paz, livre de ameaças e mal."
            },
            {
                "text": "O que despreza a Palavra, será destruído; mas o que teme o mandamento será galardoado.",
                "reference": "Provérbios 13:13",
                "message": "Valorize a instrução. Ignorar a sabedoria leva à ruína. O respeito à Palavra é o caminho para a sua recompensa."
            },
            {
                "text": "Portanto, tomai toda a armadura de Deus, para que possais resistir no dia mau e, havendo feito tudo, ficar firmes.",
                "reference": "Efésios 6:13",
                "message": "Esteja pronto. Vista sua proteção espiritual. Sua firmeza e resistência dependem da preparação. Lute e vença."
            },
            {
                "text": "Não to mandei eu? Esforça-te, e tem bom ânimo; não temas, nem te espantes; porque o Senhor teu Deus é contigo, por onde quer que andares.",
                "reference": "Josué 1:9",
                "message": "Receba a ordem: coragem! Não se intimide. Ele está com você em cada passo. Vá em frente sem medo."
            },
            {
                "text": "O temor do homem armará laços, mas o que confia no Senhor será posto em alto retiro.",
                "reference": "Provérbios 29:25",
                "message": "Não se renda ao medo do que os outros pensam. Sua segurança está em confiar totalmente. Ele o colocará acima das ameaças."
            },
            {
                "text": "Tu és o meu esconderijo e o meu escudo; na tua palavra pus a minha esperança.",
                "reference": "Salmos 119:114",
                "message": "Sua proteção é um refúgio seguro. Onde quer que você vá, Ele é seu escudo. Coloque sua esperança na Palavra e relaxe."
            },
            {
                "text": "Esforçai-vos, e animai-vos; não temais, nem vos espanteis diante deles; porque o Senhor teu Deus é o que vai contigo; não te deixará nem te desamparará.",
                "reference": "Deuteronômio 31:6",
                "message": "A ordem é clara: seja forte e corajoso! Você tem uma companhia inseparável. O abandono não é uma opção para você."
            },
            {
                "text": "Antes, seguindo a verdade em amor, cresçamos em tudo naquele que é o cabeça, Cristo.",
                "reference": "Efésios 4:15",
                "message": "O crescimento exige verdade e amor. Não se prenda à imaturidade. Sua meta é crescer em todos os aspectos. Avance."
            },
            {
                "text": "O Senhor te guardará de todo o mal; guardará a tua alma.",
                "reference": "Salmos 121:7",
                "message": "Sua segurança é total. Todo o mal será desviado de você. Confie na guarda que Ele coloca sobre sua vida e alma."
            },
            {
                "text": "Seja a vossa equidade notória a todos os homens. Perto está o Senhor.",
                "reference": "Filipenses 4:5",
                "message": "Viva com moderação e decência visível. Não há necessidade de pressa. Ele está perto para ajudar e guiar."
            },
            {
                "text": "Ora, a fé é a certeza de coisas que se esperam, a convicção de fatos que se não veem.",
                "reference": "Hebreus 11:1",
                "message": "Sua certeza não depende do que você vê. Confie na visão da fé. A convicção é a força para seguir em frente."
            },
            {
                "text": "Tudo tem o seu tempo determinado, e há tempo para todo o propósito debaixo do céu.",
                "reference": "Eclesiastes 3:1",
                "message": "Existe um tempo certo para cada coisa. Respeite o processo. Não force o que não está pronto. Sua paciência será recompensada."
            },
            {
                "text": "Sonda-me, ó Deus, e conhece o meu coração; prova-me, e conhece os meus pensamentos.",
                "reference": "Salmos 139:23",
                "message": "A verdade traz liberdade. Permita o exame profundo. Sua sinceridade em buscar a correção é valiosa."
            },
            {
                "text": "Em tudo somos atribulados, mas não angustiados; perplexos, mas não desanimados; perseguidos, mas não desamparados; abatidos, mas não destruídos.",
                "reference": "2 Coríntios 4:8-9",
                "message": "Você é resistente e inquebrável. As dificuldades não o destruirão. Sua força vem de uma fonte que não falha."
            },
            {
                "text": "O Senhor é o meu forte refúgio; de quem terei medo?",
                "reference": "Salmos 27:1",
                "message": "Seu refúgio é a força absoluta. Livre-se do medo. Sua proteção é inabalável e garantida."
            }
        ],
        "anxious": [
            {
                "text": "Porque sou eu que conheço os planos que tenho para vocês, diz o Senhor, planos de fazê-los prosperar e não de lhes causar dano, planos de dar-lhes esperança e um futuro.",
                "reference": "Jeremias 29:11",
                "message": "Mesmo na incerteza, há um plano maior de paz e esperança para você. Confie no futuro que está sendo preparado."
            },
            {
                "text": "Não andeis ansiosos por coisa alguma; antes em tudo sejam os vossos pedidos conhecidos diante de Deus pela oração e súplica com ações de graças.",
                "reference": "Filipenses 4:6",
                "message": "Transforme sua preocupação em oração. Entregue o peso e receba a paz que acalma a mente e o coração."
            },
            {
                "text": "Alegrai-vos na esperança, sede pacientes na tribulação, perseverai na oração.",
                "reference": "Romanos 12:12",
                "message": "Mantenha a esperança acesa. Seja paciente nas dificuldades e reforce sua fé. Seu ânimo será restaurado."
            },
            {
                "text": "E sabemos que todas as coisas contribuem juntamente para o bem daqueles que amam a Deus, daqueles que são chamados segundo o seu propósito.",
                "reference": "Romanos 8:28",
                "message": "Nada é por acaso. Mesmo o que parece ruim tem um propósito. Confie que tudo está sendo orquestrado para o seu bem final."
            },
            {
                "text": "Tudo tem o seu tempo determinado, e há tempo para todo o propósito debaixo do céu.",
                "reference": "Eclesiastes 3:1",
                "message": "Tudo acontece no tempo perfeito. Respeite o ritmo da vida e dos propósitos. Não force o que não está pronto para acontecer."
            },
            {
                "text": "Guarda o teu coração acima de tudo o que se deve guardar, porque dele procedem as fontes da vida.",
                "reference": "Provérbios 4:23",
                "message": "Proteja a sede da sua vida. O que você permite entrar molda o seu ser. Seja zeloso com seu coração e alma."
            },
            {
                "text": "Lança o teu fardo sobre o Senhor, e ele te susterá; nunca permitirá que o justo seja abalado.",
                "reference": "Salmos 55:22",
                "message": "Descarregue suas preocupações no Protetor. Ele sustentará você. Sua firmeza não será abalada. Descanse na certeza."
            },
            {
                "text": "O que guarda a sua boca preserva a sua alma, mas o que muito abre os lábios se destrói.",
                "reference": "Provérbios 13:3",
                "message": "Proteja sua alma com o silêncio. Palavras levianas trazem destruição. Seja guardião da sua língua."
            },
            {
                "text": "E a paz de Deus, que excede todo o entendimento, guardará os vossos corações e os vossos sentimentos em Cristo Jesus.",
                "reference": "Filipenses 4:7",
                "message": "Entregue a preocupação. Uma paz que supera a lógica humana irá guardar seu coração e sua mente."
            },
            {
                "text": "Pela manhã, ouvirás a minha voz, ó Senhor; pela manhã te apresentarei a minha oração, e vigiarei.",
                "reference": "Salmos 5:3",
                "message": "Comece o seu dia com a voz da certeza. Entregue suas preocupações em oração ao acordar. A vigilância traz paz."
            },
            {
                "text": "Tudo tem o seu tempo determinado, e há tempo para todo o propósito debaixo do céu.",
                "reference": "Eclesiastes 3:1",
                "message": "Pare de se apressar. Existe um tempo perfeito para tudo que está acontecendo. Confie no propósito e no momento certo."
            },
            {
                "text": "Lançando sobre ele toda a vossa ansiedade, porque ele tem cuidado de vós.",
                "reference": "1 Pedro 5:7",
                "message": "Não carregue o peso das suas preocupações. Ele se importa com você profundamente. Lance a ansiedade e descanse no cuidado."
            },
            {
                "text": "Não se turbe o vosso coração; credes em Deus, crede também em mim.",
                "reference": "João 14:1",
                "message": "Não permita que seu coração se perturbe. A fé é o remédio para a confusão. Confie n'Ele e encontre a serenidade."
            },
            {
                "text": "O Senhor é o meu pastor; nada me faltará.",
                "reference": "Salmos 23:1",
                "message": "Suas necessidades serão supridas. O Bom Pastor garante sua provisão. Abandone a preocupação da falta."
            },
            {
                "text": "E não vos embriagueis com vinho, em que há contenda, mas enchei-vos do Espírito.",
                "reference": "Efésios 5:18",
                "message": "Busque o preenchimento na fonte certa. Não troque a paz espiritual pela confusão mundana. O Espírito traz moderação e alívio."
            },
            {
                "text": "Perto está o Senhor de todos os que o invocam, de todos os que o invocam em verdade.",
                "reference": "Salmos 145:18",
                "message": "A ajuda está próxima. Ele responde ao seu chamado sincero. Não se sinta sozinho, a presença d'Ele é imediata."
            },
            {
                "text": "Pois todos pecaram e destituídos estão da glória de Deus.",
                "reference": "Romanos 3:23",
                "message": "Reconheça sua humanidade, mas não pare aqui. Sua falta de glória é a base para a graça futura. Busque a redenção."
            },
            {
                "text": "E o Deus de toda a graça, que em Cristo Jesus vos chamou à sua eterna glória, depois de haverdes padecido um pouco, ele mesmo vos aperfeiçoará, confirmará, fortificará e fundamentará.",
                "reference": "1 Pedro 5:10",
                "message": "Sua luta é temporária e tem um propósito divino. Ele está te aperfeiçoando e fortalecendo. Confie na obra que Ele fará."
            },
            {
                "text": "O coração do homem planeja o seu caminho, mas o Senhor lhe dirige os passos.",
                "reference": "Provérbios 16:9",
                "message": "Faça seus planos, mas entregue a direção. Você não precisa controlar tudo. O Criador está no comando dos seus passos."
            },
            {
                "text": "Tu conservarás em paz aquele cuja mente está firme em ti; porque ele confia em ti.",
                "reference": "Isaías 26:3",
                "message": "Para ter paz, mantenha sua mente concentrada. Sua confiança Nele é o segredo para a tranquilidade perfeita."
            },
            {
                "text": "Em verdade vos digo que, se tiverdes fé como um grão de mostarda, direis a este monte: Passa daqui para acolá, e ele passará. Nada vos será impossível.",
                "reference": "Mateus 17:20",
                "message": "Sua fé, mesmo que pequena, tem um poder imenso. Não duvide da capacidade de mover obstáculos. Acredite no impossível."
            },
            {
                "text": "E o meu Deus, segundo as suas riquezas em glória, suprirá todas as vossas necessidades em Cristo Jesus.",
                "reference": "Filipenses 4:19",
                "message": "Sua fonte de suprimento é inesgotável. Não se preocupe com o que falta. Suas necessidades serão supridas abundantemente."
            },
            {
                "text": "Porque onde estiver o vosso tesouro, aí estará também o vosso coração.",
                "reference": "Mateus 6:21",
                "message": "Avalie suas prioridades. Onde você investe seu tempo e afeto? Corrija seu foco para ter um coração menos preocupado."
            },
            {
                "text": "Em tudo somos atribulados, mas não angustiados; perplexos, mas não desanimados; perseguidos, mas não desamparados; abatidos, mas não destruídos.",
                "reference": "2 Coríntios 4:8-9",
                "message": "Você pode estar pressionado, mas não está esmagado. Seus problemas não o definirão. Sua resistência é maior do que a adversidade."
            },
            {
                "text": "Não se turbe o vosso coração; credes em Deus, crede também em mim.",
                "reference": "João 14:1",
                "message": "A turbulência cessa com a fé. Não permita que seu coração se perturbe. Acredite em sua Palavra e na Sua Presença."
            },
            {
                "text": "Não vos inquieteis com o dia de amanhã, pois o amanhã trará as suas próprias preocupações. Basta a cada dia o seu próprio mal.",
                "reference": "Mateus 6:34",
                "message": "Viva no presente. Não gaste sua energia com o futuro. O foco de hoje é o suficiente."
            },
            {
                "text": "Assim será a palavra que sair da minha boca; ela não voltará para mim vazia, antes fará o que me apraz, e prosperará naquilo para que a enviei.",
                "reference": "Isaías 55:11",
                "message": "A Palavra d'Ele cumpre o que promete. Não duvide. Confie na eficácia e no sucesso da Sua mensagem em sua vida. "
            },
            {
                "text": "Entrega o teu caminho ao Senhor; confia nele, e ele o fará.",
                "reference": "Salmos 37:5",
                "message": "Pare de se preocupar com o controle. Entregue sua jornada e confie plenamente. Ele agirá por você e resolverá o caminho."
            },
            {
                "text": "O Senhor não retarda a sua promessa, ainda que alguns achem que sim; mas é longânimo para conosco, não querendo que ninguém se perca, senão que todos venham ao arrependimento.",
                "reference": "2 Pedro 3:9",
                "message": "A espera não é abandono. Ele é paciente por amor. Use o tempo de espera para a transformação e crescimento."
            },
            {
                "text": "Não vos inquieteis, pois, pelo dia de amanhã, porque o dia de amanhã cuidará de si mesmo. Basta a cada dia o seu mal.",
                "reference": "Mateus 6:34",
                "message": "A preocupação com o futuro rouba o seu presente. Concentre-se no hoje. Lide com o dia atual. O amanhã esperará."
            },
            {
                "text": "E o meu Deus, segundo as suas riquezas em glória, suprirá todas as vossas necessidades em Cristo Jesus.",
                "reference": "Filipenses 4:19",
                "message": "Não se preocupe com o que falta. A fonte é infinita. Suas necessidades serão supridas por Suas riquezas gloriosas."
            },
            {
                "text": "Não vos prendais a um jugo desigual com os infiéis; porque que sociedade tem a justiça com a injustiça? E que comunhão tem a luz com as trevas?",
                "reference": "2 Coríntios 6:14",
                "message": "Escolha bem seus parceiros e associações. A desigualdade de valores trará conflito. Busque a harmonia na luz."
            },
            {
                "text": "Portanto, se o teu olho direito te escandalizar, arranca-o e atira-o para longe de ti.",
                "reference": "Mateus 5:29",
                "message": "Livre-se de tudo que o afasta do caminho. O sacrifício é necessário para proteger sua vida. Seja radical pela sua paz."
            },
            {
                "text": "Confia no Senhor de todo o teu coração e não te estribes no teu próprio entendimento.",
                "reference": "Provérbios 3:5",
                "message": "Pare de tentar entender tudo. A confiança total é o caminho para a serenidade. Renda-se à sabedoria superior."
            },
            {
                "text": "O Senhor é o meu pastor; nada me faltará.",
                "reference": "Salmos 23:1",
                "message": "Suas necessidades estão sob o cuidado do Pastor. Abandone a preocupação da falta. Você está protegido e suprido."
            },
            {
                "text": "E não vos canseis de fazer o bem, pois no tempo próprio colheremos, se não desanimarmos.",
                "reference": "Gálatas 6:9",
                "message": "Sua persistência será recompensada. Não desanime no meio do caminho. Continue a semear o bem, a colheita virá."
            },
            {
                "text": "Portanto, vede prudentemente como andais, não como néscios, mas como sábios.",
                "reference": "Efésios 5:15",
                "message": "A sabedoria está na cautela. Olhe por onde anda. Não aja por impulso. Evite o erro e a angústia."
            }
        ],
        "happy": [
            {
                "text": "Alegrem-se sempre no Senhor. Novamente direi: Alegrem-se!",
                "reference": "Filipenses 4:4",
                "message": "A alegria verdadeira é uma escolha que transcende as circunstâncias. Encontre força e contentamento no seu interior e celebre a vida."
            },
            {
                "text": "Vós sois a luz do mundo. Não se pode esconder a cidade edificada sobre um monte.",
                "reference": "Mateus 5:14",
                "message": "Você foi chamado para brilhar, não para se esconder. Sua vida deve ser um farol. Deixe sua luz iluminar a todos."
            },
            {
                "text": "Portanto, se o Filho vos libertar, verdadeiramente sereis livres.",
                "reference": "João 8:36",
                "message": "Sua liberdade é garantida. O Libertador já pagou o preço. Abandone as correntes e viva a plenitude da sua nova vida."
            },
            {
                "text": "Assim resplandeça a vossa luz diante dos homens, para que vejam as vossas boas obras e glorifiquem o vosso Pai que está nos céus.",
                "reference": "Mateus 5:16",
                "message": "Sua vida deve ser visível e inspiradora. Deixe suas ações falarem. Seu testemunho ilumina e aponta para o Bem Maior."
            },
            {
                "text": "Mas em todas estas coisas somos mais do que vencedores, por meio daquele que nos amou.",
                "reference": "Romanos 8:37",
                "message": "Sua vitória já está garantida. Você é mais que um sobrevivente. Erga-se como um vencedor através do amor que o sustenta."
            },
            {
                "text": "O Espírito do Senhor está sobre mim, porque me ungiu para pregar o evangelho aos pobres, curar os quebrantados de coração, proclamar libertação aos cativos e restauração da vista aos cegos, pôr em liberdade os oprimidos.",
                "reference": "Lucas 4:18",
                "message": "Você foi ungido para a missão. O Espírito é a sua força. Há um poder transformador em você para libertar e curar."
            },
            {
                "text": "Porque para Deus nada é impossível.",
                "reference": "Lucas 1:37",
                "message": "Não imponha limites. Aquele que pode todas as coisas está ao seu lado. Abandone a incredulidade e abrace o milagre."
            },
            {
                "text": "Deleita-te também no Senhor, e ele te concederá o que deseja o teu coração.",
                "reference": "Salmos 37:4",
                "message": "Coloque sua felicidade e seu prazer no Superior. Seus desejos mais profundos serão realizados como resultado dessa conexão."
            },
            {
                "text": "Em verdade vos digo que, se não vos converterdes e não vos fizerdes como meninos, de modo algum entrareis no reino dos céus.",
                "reference": "Mateus 18:3",
                "message": "A simplicidade e a pureza de uma criança trazem alegria. Retorne à humildade e à fé simples para viver plenamente."
            },
            {
                "text": "Regozijai-vos no Senhor e alegrai-vos, vós, justos; e cantai, todos vós que sois retos de coração.",
                "reference": "Salmos 32:11",
                "message": "Deixe a alegria transbordar. O contentamento é a sua recompensa. Cante com um coração puro e feliz."
            },
            {
                "text": "Bem-aventurado aquele cuja transgressão é perdoada, e cujo pecado é coberto.",
                "reference": "Salmos 32:1",
                "message": "A verdadeira felicidade está no perdão e na liberdade do erro. Aceite a graça e sinta a leveza de ser perdoado."
            },
            {
                "text": "Mas o fruto do Espírito é amor, alegria, paz, longanimidade, benignidade, bondade, fidelidade, mansidão, domínio próprio.",
                "reference": "Gálatas 5:22-23",
                "message": "Cultive as virtudes interiores. O resultado será alegria e harmonia. Deixe o Espírito florescer em sua vida."
            },
            {
                "text": "Pois tu, Senhor, és bom e perdoador, e abundante em benignidade para com todos os que te invocam.",
                "reference": "Salmos 86:5",
                "message": "Sinta a alegria do perdão. A bondade é abundante para quem busca. Invoque e receba o amor inesgotável."
            },
            {
                "text": "Como é feliz aquele que não segue o conselho dos ímpios, não imita a conduta dos pecadores, nem se assenta na roda dos zombadores.",
                "reference": "Salmos 1:1",
                "message": "A verdadeira felicidade está em fazer as escolhas certas. Evite o caminho da maldade. Cerque-se de boas influências."
            },
            {
                "text": "O ladrão não vem senão para roubar, matar e destruir; eu vim para que tenham vida, e a tenham em abundância.",
                "reference": "João 10:10",
                "message": "Sua vida deve ser abundante e plena. Viva o propósito do Criador. Rejeite o roubo e abrace a vida em toda a sua alegria."
            },
            {
                "text": "Alegrei-me quando me disseram: Vamos à casa do Senhor.",
                "reference": "Salmos 122:1",
                "message": "O convite à comunhão traz alegria. Celebre a oportunidade de se reunir com outros. Encontre felicidade na adoração."
            },
            {
                "text": "O coração alegre aformoseia o rosto, mas pela dor do coração o espírito se abate.",
                "reference": "Provérbios 15:13",
                "message": "Escolha cultivar a alegria, pois ela irradia beleza e saúde para sua alma. Um coração contente ilumina sua vida."
            },
            {
                "text": "A minha alma se alegra no Senhor; regozijar-se-á na sua salvação.",
                "reference": "Salmos 35:9",
                "message": "Deixe sua alma exultar! Encontre a verdadeira felicidade na libertação e na certeza da Sua intervenção."
            },
            {
                "text": "Bem-aventurado aquele que teme ao Senhor e anda nos seus caminhos.",
                "reference": "Salmos 128:1",
                "message": "A verdadeira bênção se encontra na obediência. A felicidade é o resultado de caminhar no propósito traçado para você."
            },
            {
                "text": "Alegrai-vos com tremor.",
                "reference": "Salmos 2:11",
                "message": "Celebre sua vida e conquistas com reverência e respeito. A alegria deve ser vivida com consciência e gratidão."
            },
            {
                "text": "Bem-aventurado o que acode ao pobre; o Senhor o livrará no dia do mal.",
                "reference": "Salmos 41:1",
                "message": "Sua generosidade traz felicidade e proteção. O cuidado com o próximo é um investimento seguro que lhe trará livramento."
            },
            {
                "text": "Não vos alegreis, porque se vos sujeitem os espíritos; alegrai-vos, antes, por estarem os vossos nomes escritos nos céus.",
                "reference": "Lucas 10:20",
                "message": "Sua maior alegria deve estar na sua identidade eterna. As conquistas terrenas são menores que a certeza da sua salvação."
            },
            {
                "text": "Assim resplandeça a vossa luz diante dos homens, para que vejam as vossas boas obras e glorifiquem o vosso Pai que está nos céus.",
                "reference": "Mateus 5:16",
                "message": "Sua vida é um farol. Deixe suas ações falarem e inspire outros. Brilhe para que o Altíssimo seja glorificado através de você.   "
            },
            {
                "text": "Porque a sua ira dura só um momento; e no seu favor está a vida. O choro pode durar uma noite, mas a alegria vem pela manhã.",
                "reference": "Salmos 30:5",
                "message": "Seu favor é eterno e alegre. A tristeza é uma visita breve. Abrace a certeza do novo dia e da felicidade."
            },
            {
                "text": "Alegrei-me quando me disseram: Vamos à casa do Senhor.",
                "reference": "Salmos 122:1",
                "message": "O convite à comunhão traz alegria. Celebre a oportunidade de se reunir com outros. Encontre felicidade na adoração."
            },
            {
                "text": "Regozijai-vos no Senhor e alegrai-vos, vós, justos; e cantai, todos vós que sois retos de coração.",
                "reference": "Salmos 32:11",
                "message": "A alegria é um direito do justo. Deixe seu coração reto transbordar. Cante e celebre sua condição."
            },
            {
                "text": "Regozijai-vos na esperança, sede pacientes na tribulação, perseverai na oração.",
                "reference": "Romanos 12:12",
                "message": "A esperança é o motivo da sua alegria. Seja paciente na dificuldade e persistente na fé. Sua celebração virá em breve."
            },
            {
                "text": "Amaste a justiça e odiaste a iniquidade; por isso Deus, o teu Deus, te ungiu com óleo de alegria mais do que a teus companheiros.",
                "reference": "Hebreus 1:9",
                "message": "Sua escolha pela retidão é reconhecida e recompensada. Receba a alegria que o diferencia. Viva em contentamento."
            },
            {
                "text": "Aquele que leva a preciosa semente, andando e chorando, voltará sem dúvida com alegria, trazendo consigo os seus molhos.",
                "reference": "Salmos 126:6",
                "message": "Seu esforço em lágrimas não é em vão. A colheita será celebrada. O plantio difícil resultará em grande alegria."
            },
            {
                "text": "O choro pode durar uma noite, mas a alegria vem pela manhã.",
                "reference": "Salmos 30:5",
                "message": "Sua tristeza tem prazo de validade. Espere o amanhecer. A alegria virá para coroar sua perseverança noturna."
            },
            {
                "text": "O justo florescerá como a palmeira, crescerá como o cedro no Líbano.",
                "reference": "Salmos 92:12",
                "message": "Você foi feito para prosperar. Sua vida será marcada pela força e pelo florescimento. A alegria é o fruto da sua retidão."
            },
            {
                "text": "Alegrai-vos sempre no Senhor. Repito: alegrai-vos!",
                "reference": "Filipenses 4:4",
                "message": "A alegria é uma ordem e uma escolha que transcende a tristeza. Repita essa verdade para o seu coração."
            },
            {
                "text": "Alegrei-me quando me disseram: Vamos à casa do Senhor.",
                "reference": "Salmos 122:1",
                "message": "O convite à comunhão é motivo de celebração. Encontre felicidade na reunião com outros e na adoração."
            },
            {
                "text": "Alegrai-vos com tremor.",
                "reference": "Salmos 2:11",
                "message": "Sua alegria deve ser reverente e consciente. Celebre a vida com profundo respeito pelo Doador."
            },
            {
                "text": "Bem-aventurado aquele cuja transgressão é perdoada, e cujo pecado é coberto.",
                "reference": "Salmos 32:1",
                "message": "A verdadeira felicidade é a liberdade da culpa. Aceite o perdão e sinta a leveza de um recomeço."
            }
        ],
        "peaceful": [
            {
                "text": "Deus é o nosso refúgio e a nossa força, socorro que não falta em tempos de aflição.",
                "reference": "Salmos 46:1",
                "message": "Você não está sozinho para suportar essa aflição. Seu socorro é imediato e seguro. Descanse e encontre renovo."
            },
            {
                "text": "Portanto, se alguém está em Cristo, é nova criação. As coisas antigas já passaram; eis que surgiram coisas novas!",
                "reference": "2 Coríntios 5:17",
                "message": "Seu passado não define seu valor. Aceite a chance de recomeçar hoje. Você é uma nova pessoa, livre para seguir em frente."
            },
            {
                "text": "O Senhor é bom, uma fortaleza no dia da angústia; e conhece os que confiam nele.",
                "reference": "Naum 1:7",
                "message": "Você tem um refúgio seguro. O Bom Pastor conhece você e sua angústia. Confie na força dele para guiá-lo."
            },
            {
                "text": "Orai sem cessar.",
                "reference": "1 Tessalonicenses 5:17",
                "message": "Faça da oração o seu ritmo de vida. Mantenha a linha direta sempre aberta, em todo momento. A conexão é a sua âncora."
            },
            {
                "text": "Buscai antes o reino de Deus e a sua justiça, e todas estas coisas vos serão acrescentadas.",
                "reference": "Mateus 6:33",
                "message": "Coloque suas prioridades em ordem. Busque primeiro o que é eterno e todas as suas necessidades serão supridas."
            },
            {
                "text": "Melhor é o fim das coisas do que o princípio delas; melhor é o paciente de espírito do que o altivo de espírito.",
                "reference": "Eclesiastes 7:8",
                "message": "A pressa é inimiga da perfeição. A paciência traz a melhor conclusão. Seja humilde e persistente, o tempo trará a vitória."
            },
            {
                "text": "Assim, pois, a fé vem pelo ouvir, e o ouvir pela palavra de Cristo.",
                "reference": "Romanos 10:17",
                "message": "Aumente sua fé ouvindo a mensagem. A Palavra é a semente. Receba-a e veja sua crença crescer e se fortalecer."
            },
            {
                "text": "Quem perdoa uma ofensa, demonstra amor, mas quem remoe o assunto, afasta amigos íntimos.",
                "reference": "Provérbios 17:9",
                "message": "Liberte-se do ressentimento através do perdão. O amor supera a mágoa. Preserve suas relações com a bondade."
            },
            {
                "text": "Em paz me deito e logo durmo, porque só tu, Senhor, me fazes habitar em segurança.",
                "reference": "Salmos 4:8",
                "message": "Confie sua noite ao Guardião. A segurança que Ele oferece acalma a mente. Deite-se em paz e descanse profundamente."
            },
            {
                "text": "Melhor é um punhado com descanso do que ambos os punhados com trabalho e enfado do espírito.",
                "reference": "Eclesiastes 4:6",
                "message": "O descanso não é luxo, é necessidade. Encontre o equilíbrio e evite o esgotamento. Valorize a paz sobre o excesso de esforço."
            },
            {
                "text": "O que confia no Senhor, a misericórdia o cercará.",
                "reference": "Salmos 32:10",
                "message": "Sua confiança é a sua proteção. Você está cercado pela bondade e pelo amor. Abrace a misericórdia que o envolve e o guarda."
            },
            {
                "text": "Sede uns para com os outros benignos, misericordiosos, perdoando-vos uns aos outros, como também Deus vos perdoou em Cristo.",
                "reference": "Efésios 4:32",
                "message": "Imite a misericórdia que você recebeu. A bondade cura o coração. Perdoe e liberte a si mesmo da amargura."
            },
            {
                "text": "O Senhor aperfeiçoará o que me diz respeito; a tua misericórdia, ó Senhor, dura para sempre; não desampares as obras das tuas mãos.",
                "reference": "Salmos 138:8",
                "message": "O Artesão está trabalhando em você. Ele completará a Sua obra. Sua misericórdia é eterna. Confie no processo de aperfeiçoamento."
            },
            {
                "text": "Mas, sobretudo, tende ardente amor uns para com os outros; porque o amor cobrirá a multidão de pecados.",
                "reference": "1 Pedro 4:8",
                "message": "O amor é o cimento da união. Coloque o amor acima de tudo. Cubra as falhas com bondade e promova a paz."
            },
            {
                "text": "Em Tiago 1:19: Sabei isto, meus amados irmãos: Todo homem seja pronto para ouvir, tardio para falar e tardio para se irar.",
                "reference": "Tiago 1:19",
                "message": "Ouça primeiro, fale depois, e a raiva se acalmará. A pressa em responder leva a erros. Pratique a moderação."
            },
            {
                "text": "Bendito o homem que confia no Senhor, e cuja esperança é o Senhor.",
                "reference": "Jeremias 17:7",
                "message": "Sua confiança é a fonte de sua bênção. Mantenha a esperança inabalável, e você encontrará uma paz profunda."
            },
            {
                "text": "O coração em paz dá vida ao corpo, mas a inveja apodrece os ossos.",
                "reference": "Provérbios 14:30",
                "message": "Cultive a tranquilidade interior. Seu estado de espírito afeta sua saúde. Escolha a paz para ter vida e vigor."
            },
            {
                "text": "Não digas: Vingar-me-ei do mal; espera pelo Senhor, e ele te livrará.",
                "reference": "Provérbios 20:22",
                "message": "Abandone o desejo de vingança. Entregue a justiça ao Juiz. A calma e a espera trarão a sua libertação."
            },
            {
                "text": "Mas ele foi ferido pelas nossas transgressões, e moído pelas nossas iniquidades; o castigo que nos traz a paz estava sobre ele, e pelas suas pisaduras fomos sarados.",
                "reference": "Isaías 53:5",
                "message": "Sua cura e sua paz têm um custo. Receba o alívio que foi conquistado por você. Descanse na paz desse sacrifício."
            },
            {
                "text": "Portanto, não vos inquieteis com o dia de amanhã, pois o amanhã trará as suas próprias preocupações. Basta a cada dia o seu próprio mal.",
                "reference": "Mateus 6:34",
                "message": "Viva um dia de cada vez. Concentre sua energia no presente. Acalme-se, o amanhã tem o seu próprio tempo."
            },
            {
                "text": "Alegrai-vos na esperança, sede pacientes na tribulação, perseverai na oração.",
                "reference": "Romanos 12:12",
                "message": "A esperança é sua âncora. Use a paciência na dificuldade e a oração como sua persistência. A paz virá."
            },
            {
                "text": "Melhor é o pouco com justiça do que grandes rendas com injustiça.",
                "reference": "Provérbios 16:8",
                "message": "Valorize a integridade sobre o lucro. A paz de uma consciência limpa vale mais que a riqueza desonesta."
            },
            {
                "text": "Toda a Escritura é divinamente inspirada e proveitosa para ensinar, para repreender, para corrigir, para instruir em justiça.",
                "reference": "2 Timóteo 3:16",
                "message": "Sua bússola é infalível. A Palavra o guiará em todas as correções necessárias. Busque nela a instrução para viver em paz.     "
            },
            {
                "text": "E nós temos crido e conhecido que tu és o Cristo, o Filho de Deus vivo.",
                "reference": "João 6:69",
                "message": "Sua fundação é sólida e imutável. O conhecimento da verdade traz paz e certeza. Descanse na identidade do seu Salvador."
            },
            {
                "text": "Mas a vereda dos justos é como a luz da aurora, que vai brilhando mais e mais até ser dia perfeito.",
                "reference": "Provérbios 4:18",
                "message": "Seu caminho é de clareza crescente. A luz aumenta à medida que você avança. Confie no progresso e na perfeição final."
            },
            {
                "text": "Não vos vingueis a vós mesmos, amados, mas dai lugar à ira; porque está escrito: Minha é a vingança; eu recompensarei, diz o Senhor.",
                "reference": "Romanos 12:19",
                "message": "Liberte-se da necessidade de revidar. Entregue o desejo de vingança ao Justo. A paz é sua recompensa por confiar.       "
            },
            {
                "text": "Mas, buscai primeiro o reino de Deus, e a sua justiça, e todas estas coisas vos serão acrescentadas.",
                "reference": "Mateus 6:33",
                "message": "Priorize o eterno sobre o temporal. Sua busca pela justiça trará ordem e paz à sua vida. O resto virá por acréscimo."
            },
            {
                "text": "Não vos vingueis a vós mesmos, amados, mas dai lugar à ira; porque está escrito: Minha é a vingança; eu recompensarei, diz o Senhor.",
                "reference": "Romanos 12:19",
                "message": "Abandone a vingança. Entregue a justiça ao Juiz. A calma e a confiança na retribuição d'Ele lhe trarão paz."
            },
            {
                "text": "Mas os justos herdarão a terra e nela habitarão para sempre.",
                "reference": "Salmos 37:29",
                "message": "Seu futuro está garantido. Viva com integridade e a paz será sua herança. A permanência é eterna para quem é justo."
            },
            {
                "text": "Deixo-vos a paz, a minha paz vos dou; não vo-la dou como o mundo a dá. Não se turbe o vosso coração, nem se atemorize.",
                "reference": "João 14:27",
                "message": "Receba a paz que é diferente de tudo que o mundo oferece. Não se perturbe, nem tenha medo. Sua serenidade é um presente."
            },
            {
                "text": "O que encobre as suas transgressões nunca prosperará, mas o que as confessa e as abandona alcançará misericórdia.",
                "reference": "Provérbios 28:13",
                "message": "A confissão é o caminho para a paz. Pare de esconder seus erros. A misericórdia o libertará para viver em prosperidade."
            },
            {
                "text": "Porque para mim o viver é Cristo e o morrer é ganho.",
                "reference": "Filipenses 1:21",
                "message": "Sua vida tem um propósito supremo e seu futuro é seguro. Viver é Cristo, morrer é lucro. Viva e morra em paz."
            },
            {
                "text": "O Espírito Santo... em todas as coisas vos fará lembrar de tudo o que vos tenho dito.",
                "reference": "João 14:26",
                "message": "Você tem um Mestre e um Guia. O Espírito o lembrará da verdade quando necessário. Confie nessa orientação constante."
            },
            {
                "text": "Sabei que o Senhor é Deus; foi ele quem nos fez, e não nós a nós mesmos; somos o seu povo e ovelhas do seu pasto.",
                "reference": "Salmos 100:3",
                "message": "Reconheça sua origem e seu lugar. Você é amado e cuidado. Descanse na certeza de pertencer ao Bom Pastor."
            },
            {
                "text": "Porque eu bem sei os pensamentos que tenho a vosso respeito, diz o Senhor; pensamentos de paz, e não de mal, para vos dar o fim que esperais.",
                "reference": "Jeremias 29:11",
                "message": "Seu futuro é planejado com paz e esperança. Descanse nos pensamentos do Criador para sua vida. O final será bom."
            },
            {
                "text": "O Senhor é tardio em irar-se, e grande em poder, e ao transgressor de maneira nenhuma terá por inocente.",
                "reference": "Naum 1:3",
                "message": "A paz é garantida, mas a justiça virá. Confie na Sua paciência. Ele é poderoso e não ignora a maldade."
            },
            {
                "text": "Melhor é o pouco com justiça do que grandes rendas com injustiça.",
                "reference": "Provérbios 16:8",
                "message": "A integridade é mais valiosa do que a riqueza. O pouco com paz de espírito é melhor do que o muito com agitação."
            },
            {
                "text": "O Senhor é o meu pastor; nada me faltará.",
                "reference": "Salmos 23:1",
                "message": "Você está sob o melhor cuidado. Suas necessidades serão supridas. Descanse na provisão e na paz do seu Pastor."
            },
            {
                "text": "A saber, a justiça de Deus pela fé em Jesus Cristo para todos e sobre todos os que creem; porque não há diferença.",
                "reference": "Romanos 3:22",
                "message": "A justiça é acessível a todos. A paz vem através da fé. Sua posição diante d'Ele é segura."
            },
            {
                "text": "Mas, se andarmos na luz, como ele na luz está, temos comunhão uns com os outros, e o sangue de Jesus Cristo, seu Filho, nos purifica de todo o pecado.",
                "reference": "1 João 1:7",
                "message": "A luz traz comunhão e liberdade da culpa. Viva em transparência. Sua purificação é completa e garante a paz."
            },
            {
                "text": "O que guarda a sua boca e a sua língua guarda a sua alma de angústias.",
                "reference": "Provérbios 21:23",
                "message": "Cuidado com o que você diz. O controle das palavras é a chave para evitar conflitos e a angústia. Mantenha a calma."
            },
            {
                "text": "E ele lhes disse: Onde está a vossa fé? E eles, temendo, maravilharam-se, dizendo uns aos outros: Quem é este que até o vento e a água lhe obedecem?",
                "reference": "Lucas 8:25",
                "message": "Sua fé silencia as tempestades. Não tema a força dos elementos. O Criador está no controle. Acalme-se. "
            },
            {
                "text": "Mas a sabedoria que vem do alto é, primeiramente, pura, depois pacífica, moderada, tratável, cheia de misericórdia e de bons frutos, sem parcialidade, e sem hipocrisia.",
                "reference": "Tiago 3:17",
                "message": "A verdadeira sabedoria é a paz em ação. Cultive a pureza e a misericórdia. Sua vida será um fruto de tranquilidade."
            },
            {
                "text": "E em nenhum outro há salvação, porque também debaixo do céu nenhum outro nome há, dado entre os homens, pelo qual devamos ser salvos.",
                "reference": "Atos 4:12",
                "message": "A certeza da salvação está em um só Nome. Encontre a segurança e a paz nesse fundamento inabalável."
            },
            {
                "text": "O homem bom tira coisas boas do bom tesouro que tem em seu coração, e o mau, coisas más do seu mau tesouro, pois a boca fala do que está cheio o coração.",
                "reference": "Lucas 6:45",
                "message": "Cuide do seu interior. O que está em seu coração determina o que você fala. A bondade interior gera paz."
            },
            {
                "text": "Mas o fruto do Espírito é amor, alegria, paz, longanimidade, benignidade, bondade, fidelidade, mansidão, domínio próprio.",
                "reference": "Gálatas 5:22-23",
                "message": "Cultive as virtudes que trazem paz e alegria. O domínio próprio é o segredo para uma vida em equilíbrio."
            },
            {
                "text": "Por isso não desfalecemos; mas, ainda que o nosso homem exterior se corrompa, o interior, contudo, se renova de dia em dia.",
                "reference": "2 Coríntios 4:16",
                "message": "Sua força é interior e diária. Não se preocupe com o desgaste físico. Seu espírito se renova a cada manhã.    "
            },
            {
                "text": "Orai sem cessar.",
                "reference": "1 Tessalonicenses 5:17",
                "message": "Faça da oração seu hábito de vida. Mantenha a conexão sempre aberta. A paz está em conversar constantemente."
            },
            {
                "text": "O meu socorro vem do Senhor, que fez o céu e a terra.",
                "reference": "Salmos 121:2",
                "message": "Sua ajuda vem do Criador de tudo. Olhe para cima e encontre força. Não há limite para o poder de quem te socorre."
            },
            {
                "text": "O que é rico não tem de dar mais, nem o pobre menos, para o resgate da sua vida.",
                "reference": "Êxodo 30:15",
                "message": "Seu valor é o mesmo de todos. A igualdade perante o Criador traz paz. Seu status terreno não o define."
            },
            {
                "text": "Melhor é ser humilde de espírito com os mansos do que repartir o despojo com os soberbos.",
                "reference": "Provérbios 16:19",
                "message": "A humildade traz paz interior. Escolha a mansidão sobre o orgulho. A calma da simplicidade é a maior recompensa."
            }
        ],
        "sad": [
            {
                "text": "Vinde a mim, todos os que estais cansados e oprimidos, e eu vos aliviarei.",
                "reference": "Mateus 11:28",
                "message": "Não carregue esse peso sozinho. Entregue seu cansaço e opressão. Há um descanso e alívio verdadeiro esperando por você."
            },
            {
                "text": "Aquele que leva a preciosa semente, andando e chorando, voltará sem dúvida com alegria, trazendo consigo os seus molhos.",
                "reference": "Salmos 126:6",
                "message": "O seu trabalho, mesmo em lágrimas, não é em vão. Continue semeando. A colheita será abundante e cheia de alegria."
            },
            {
                "text": "Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna.",
                "reference": "João 3:16",
                "message": "Você é amado com uma medida sacrificial. Existe vida eterna e esperança garantida. Acredite no poder desse amor."
            },
            {
                "text": "Por isso não desfalecemos; mas, ainda que o nosso homem exterior se corrompa, o interior, contudo, se renova de dia em dia.",
                "reference": "2 Coríntios 4:16",
                "message": "Seu corpo pode estar cansado, mas seu espírito se fortalece a cada amanhecer. Busque a renovação interior diária."
            },
            {
                "text": "Pois o salário do pecado é a morte, mas o dom gratuito de Deus é a vida eterna em Cristo Jesus, nosso Senhor.",
                "reference": "Romanos 6:23",
                "message": "Há um caminho de retorno. O preço foi pago. Receba o presente da vida eterna. Escolha a graça sobre a condenação."
            },
            {
                "text": "O coração alegre é bom remédio, mas o espírito abatido seca os ossos.",
                "reference": "Provérbios 17:22",
                "message": "Escolha a alegria como sua cura. Um coração contente é o melhor medicamento para a alma. Anime-se e revigore-se."
            },
            {
                "text": "Porque o choro pode durar uma noite, mas a alegria vem pela manhã.",
                "reference": "Salmos 30:5",
                "message": "A dor é temporária, mas a alegria está a caminho. Suporte a noite, pois um novo amanhecer de felicidade virá."
            },
            {
                "text": "Por que estás abatida, ó minha alma, e por que te perturbas em mim? Espera em Deus, pois ainda o louvarei pela salvação da sua face.",
                "reference": "Salmos 42:5",
                "message": "Não se entregue ao desânimo. Lute contra a tristeza com esperança. Você ainda terá motivos para louvar e celebrar."
            },
            {
                "text": "A quem tenho eu no céu senão a ti? E na terra não há quem eu deseje além de ti.",
                "reference": "Salmos 73:25",
                "message": "Mesmo na maior solidão, você tem a Fonte de todo o desejo. Seu coração encontra satisfação plena n'Ele."
            },
            {
                "text": "Espera no Senhor, anima-te, e ele fortalecerá o teu coração; espera, pois, no Senhor.",
                "reference": "Salmos 27:14",
                "message": "Seja forte e espere. O tempo d'Ele não é o seu, mas vale a pena. A espera trará força e renovo ao seu coração."
            },
            {
                "text": "Jesus chorou.",
                "reference": "João 11:35",
                "message": "Ele entende a sua dor. O sofrimento não é ignorado. Permita-se sentir, sabendo que há compaixão e consolo."
            },
            {
                "text": "Ainda que a figueira não floresça, nem haja fruto nas vides; ainda que falhe o produto da oliveira, e os campos não produzam mantimento; ainda que o rebanho seja exterminado do curral e não haja gado nos estábulos.",
                "reference": "Habacuque 3:17",
                "message": "Mesmo na maior das perdas e faltas, sua alegria pode persistir. Sua felicidade não depende das circunstâncias, mas da fé."
            },
            {
                "text": "O Senhor é compassivo e misericordioso, longânimo e grande em benignidade.",
                "reference": "Salmos 103:8",
                "message": "Lembre-se do caráter D'ele: lento para a ira e rico em amor. Sua dor é vista com grande compaixão e misericórdia."
            },
            {
                "text": "Os sacrifícios para Deus são o espírito quebrantado; um coração quebrantado e contrito, ó Deus, não desprezarás.",
                "reference": "Salmos 51:17",
                "message": "Sua humildade e arrependimento são preciosos. Entregue sua dor. Um coração sincero e contrito jamais será rejeitado."
            },
            {
                "text": "O Senhor está perto dos que têm o coração quebrantado e salva os de espírito oprimido.",
                "reference": "Salmos 34:18",
                "message": "Quando você se sente mais fraco, Ele está mais perto. Sua dor e opressão são vistas. O auxílio está a caminho."
            },
            {
                "text": "Perto está o Senhor dos que têm o coração quebrantado e salva os de espírito abatido.",
                "reference": "Salmos 34:18",
                "message": "Em seu momento de maior fragilidade, Ele está mais próximo. A salvação está reservada para os corações humildes e tristes."
            },
            {
                "text": "Pois a sua ira dura só um momento, mas o seu favor dura a vida toda; o choro pode persistir uma noite, mas de manhã irrompe a alegria.",
                "reference": "Salmos 30:5",
                "message": "Lembre-se da brevidade da dor. O favor d'Ele é constante. A tristeza passa, mas a alegria é o seu destino."
            },
            {
                "text": "Bendito seja o Deus e Pai de nosso Senhor Jesus Cristo, o Pai das misericórdias e o Deus de toda a consolação.",
                "reference": "2 Coríntios 1:3",
                "message": "A consolação está na sua origem. Ele é o Pai de toda misericórdia. Seu sofrimento será transformado em conforto."
            },
            {
                "text": "Ele cura os que têm o coração quebrantado e trata de suas feridas.",
                "reference": "Salmos 147:3",
                "message": "Sua dor é vista e tratada. O Curador se inclina para restaurar as feridas da alma. Receba o toque de cura."
            },
            {
                "text": "Não me lanceis fora da tua presença, e não retires de mim o teu Espírito Santo.",
                "reference": "Salmos 51:11",
                "message": "Seu maior medo é o abandono. Peça para ser restaurado à Presença. A conexão espiritual é o seu maior consolo."
            },
            {
                "text": "O Senhor é tardio em irar-se, e grande em poder, e ao transgressor de maneira nenhuma terá por inocente.",
                "reference": "Naum 1:3",
                "message": "Reconheça Sua grande paciência. Ele não se apressa em julgar. Sua misericórdia lhe dá tempo para mudar e buscar a paz."
            },
            {
                "text": "Lava-me completamente da minha iniquidade e purifica-me do meu pecado.",
                "reference": "Salmos 51:2",
                "message": "Sua sinceridade no pedido de perdão é o primeiro passo para o consolo. Busque a purificação completa da culpa."
            },
            {
                "text": "Se o meu povo, que se chama pelo meu nome, se humilhar, e orar, e buscar a minha face e se converter dos seus maus caminhos, então eu ouvirei dos céus, e perdoarei os seus pecados, e sararei a sua terra.",
                "reference": "2 Crônicas 7:14",
                "message": "A cura da sua vida e ambiente começa com a humildade e a oração. O arrependimento é o caminho para a restauração."
            },
            {
                "text": "O Senhor é compassivo e misericordioso, longânimo e grande em benignidade.",
                "reference": "Salmos 103:8",
                "message": "Ele vê sua dor com profunda compaixão. Sua misericórdia é maior que sua tristeza. Recorra ao Seu amor constante."
            },
            {
                "text": "Porque a vós vos foi concedido, em relação a Cristo, não somente crer nele, mas também padecer por ele.",
                "reference": "Filipenses 1:29",
                "message": "Sua dor tem um propósito maior. Sofrer por uma causa nobre é uma honra. Sua fé é aperfeiçoada na tribulação."
            },
            {
                "text": "Porquanto, ainda que a figueira não floresça, nem haja fruto na vide; o produto da oliveira minta, e os campos não produzam mantimento; as ovelhas da malhada sejam arrebatadas, e nos currais não haja vacas, todavia, eu me alegrarei no Senhor, exultarei no Deus da minha salvação.",
                "reference": "Habacuque 3:17-18",
                "message": "Sua alegria é incondicional. Mesmo na perda total, escolha exultar no Criador. Sua felicidade não depende do que você tem."
            },
            {
                "text": "O qual nos consolou em toda a nossa tribulação, para que também possamos consolar os que estiverem em alguma tribulação, com a consolação com que nós mesmos somos consolados de Deus.",
                "reference": "2 Coríntios 1:4",
                "message": "Sua experiência de dor é um instrumento de consolo. Use a paz que você recebeu para ajudar outros em suas tristezas."
            }
        ],
        "grateful": [
            {
                "text": "Combati o bom combate, terminei a corrida, guardei a fé.",
                "reference": "2 Timóteo 4:7",
                "message": "Sinta orgulho da jornada percorrida e da sua persistência. A sua luta tem valor e o seu esforço será recompensado."
            },
            {
                "text": "Porque onde estiverem dois ou três reunidos em meu nome, ali estou eu no meio deles.",
                "reference": "Mateus 18:20",
                "message": "Você nunca está sozinho. A união com outros atrai uma presença poderosa. Encontre força na comunidade."
            },
            {
                "text": "Retribui ao Senhor por todo o bem que ele te tem feito.",
                "reference": "Salmos 116:12",
                "message": "Pare e conte suas bênçãos. A gratidão é a chave para o contentamento. Responda ao bem com um coração cheio de louvor."
            },
            {
                "text": "Em tudo dai graças, porque esta é a vontade de Deus em Cristo Jesus para convosco.",
                "reference": "1 Tessalonicenses 5:18",
                "message": "A gratidão é o centro da vontade divina. Mesmo nas dificuldades, encontre razões para agradecer. Isso transforma sua perspectiva."
            },
            {
                "text": "Porque o amor de Cristo nos constrange, julgando nós isto: que, se um morreu por todos, logo todos morreram.",
                "reference": "2 Coríntios 5:14",
                "message": "O maior ato de amor deve impulsionar sua vida. Deixe-se mover por essa causa. Viva com o propósito daquele que o amou."
            },
            {
                "text": "Em amor, o aperfeiçoamento dos santos, para o trabalho do ministério, para a edificação do corpo de Cristo.",
                "reference": "Efésios 4:12",
                "message": "Você faz parte de algo maior. Trabalhe com amor para edificar a comunidade. Juntos, vocês se aperfeiçoam."
            },
            {
                "text": "Alegrai-vos com os que se alegram; e chorai com os que choram.",
                "reference": "Romanos 12:15",
                "message": "Compartilhe as emoções alheias. A empatia fortalece os laços. Celebre e console, vivendo a verdadeira comunidade."
            },
            {
                "text": "Tudo o que fizerem, façam de todo o coração, como para o Senhor, e não para os homens.",
                "reference": "Colossenses 3:23",
                "message": "Coloque paixão e excelência em tudo. Seu trabalho é para o Altíssimo. Dê o seu melhor e sua dedicação será recompensada."
            },
            {
                "text": "Eis que estou à porta e bato; se alguém ouvir a minha voz, e abrir a porta, entrarei em sua casa, e cearei com ele, e ele comigo.",
                "reference": "Apocalipse 3:20",
                "message": "Ele está chamando. Abra o seu coração. Um banquete de comunhão espera por você. Permita a entrada da vida plena."
            },
            {
                "text": "Porque somos criação de Deus, realizados em Cristo Jesus para fazermos boas obras, as quais Deus preparou de antemão para que nós as praticássemos.",
                "reference": "Efésios 2:10",
                "message": "Você foi feito para um propósito. Boas obras o aguardam. Avance com confiança, o caminho já foi traçado para você."
            },
            {
                "text": "O temor do Senhor é o princípio da sabedoria, e o conhecimento do Santo a prudência.",
                "reference": "Provérbios 9:10",
                "message": "Busque o conhecimento da verdade. Comece pelo respeito ao sagrado. A sabedoria e a prudência o guiarão para a vida plena."
            },
            {
                "text": "Aquele que não poupou a seu próprio Filho, antes o entregou por todos nós, como nos não dará também com ele todas as coisas?",
                "reference": "Romanos 8:32",
                "message": "Se o maior presente foi dado, confie que Ele proverá o resto. Aceite o amor sacrificial com um coração grato."
            },
            {
                "text": "Dai graças ao Senhor, porque ele é bom; porque a sua benignidade dura para sempre.",
                "reference": "Salmos 107:1",
                "message": "A bondade e o amor são eternos. Agradeça sempre por essa constância. Sua fidelidade merece sua gratidão contínua."
            },
            {
                "text": "O Senhor é a minha porção e a minha taça; tu sustentas a minha sorte.",
                "reference": "Salmos 16:5",
                "message": "Sua maior herança é o Provedor. Ele sustenta seu destino. Alegre-se com a porção que lhe foi dada."
            },
            {
                "text": "O Senhor dá força ao seu povo; o Senhor abençoa o seu povo com paz.",
                "reference": "Salmos 29:11",
                "message": "Você recebeu uma dupla bênção: força para lutar e paz para descansar. Seja grato por esse cuidado constante."
            },
            {
                "text": "E a esperança não desaponta, porque o amor de Deus foi derramado em nosso coração pelo Espírito Santo que nos foi dado.",
                "reference": "Romanos 5:5",
                "message": "Sua esperança é real e confiável. Você foi inundado com um amor que não falha. Viva com a certeza desse dom."
            },
            {
                "text": "Até aqui nos ajudou o Senhor.",
                "reference": "1 Samuel 7:12",
                "message": "Olhe para trás e reconheça a ajuda recebida. Sinta a gratidão pela fidelidade constante. O cuidado d'Ele é ininterrupto."
            },
            {
                "text": "Instrui o sábio, e ele se fará mais sábio; ensina o justo, e ele aumentará em conhecimento.",
                "reference": "Provérbios 9:9",
                "message": "Aprenda e cresça. A sabedoria não é estática. Agradeça pelas oportunidades de expandir seu conhecimento e discernimento."
            },
            {
                "text": "A longanimidade do Senhor é salvação.",
                "reference": "2 Pedro 3:15",
                "message": "Seja grato pela paciência d'Ele. Sua tolerância é a sua oportunidade de salvação. Use esse tempo para se arrepender e mudar."
            },
            {
                "text": "O Senhor é a minha força e o meu escudo; nele o meu coração confia, e dele recebo ajuda. Meu coração exulta de alegria, e com o meu cântico lhe darei graças.",
                "reference": "Salmos 28:7",
                "message": "Sua confiança é a sua força. Quando você confia, a alegria transborda. Cante sua gratidão e celebre o socorro recebido."
            },
            {
                "text": "O amigo ama em todos os momentos; é um irmão na adversidade.",
                "reference": "Provérbios 17:17",
                "message": "Valorize quem está ao seu lado nas dificuldades. A amizade verdadeira é um dom precioso. Seja grato por ter um irmão no sofrimento."
            },
            {
                "text": "Louvar-te-ei, Senhor, de todo o meu coração; contarei todas as tuas maravilhas.",
                "reference": "Salmos 9:1",
                "message": "Seu coração transborda em louvor. Não guarde as maravilhas que Ele fez. Compartilhe sua gratidão e suas experiências."
            },
            {
                "text": "Assim será a palavra que sair da minha boca; ela não voltará para mim vazia, antes fará o que me apraz, e prosperará naquilo para que a enviei.",
                "reference": "Isaías 55:11",
                "message": "A Palavra d'Ele é poderosa e eficaz. Seja grato pela Sua promessa de sucesso. O que Ele fala, Ele realiza."
            },
            {
                "text": "Na casa de meu Pai há muitas moradas; se não fosse assim, eu vo-lo teria dito. Vou preparar-vos lugar.",
                "reference": "João 14:2",
                "message": "Sua esperança e seu futuro estão seguros. Seja grato pela promessa de um lar eterno. Viva com o coração tranquilo."
            },
            {
                "text": "O que é rico não tem de dar mais, nem o pobre menos, para o resgate da sua vida.",
                "reference": "Êxodo 30:15",
                "message": "Seu valor é igual e inestimável. Agradeça por ter o mesmo preço de resgate. Seu status não define sua importância."
            },
            {
                "text": "O caminho do preguiçoso é como um sebe de espinhos, mas a vereda dos justos é plana.",
                "reference": "Provérbios 15:19",
                "message": "Agradeça pela clareza do seu caminho. O trabalho justo e a diligência removem os obstáculos da preguiça."
            },
            {
                "text": "Mas, se andarmos na luz, como ele na luz está, temos comunhão uns com os outros, e o sangue de Jesus Cristo, seu Filho, nos purifica de todo o pecado.",
                "reference": "1 João 1:7",
                "message": "A luz traz comunhão e limpeza. Seja grato pela purificação completa. Sua vida em comunidade é um presente."
            },
            {
                "text": "Tendo por certo isto mesmo, que aquele que em vós começou a boa obra a aperfeiçoará até ao dia de Jesus Cristo.",
                "reference": "Filipenses 1:6",
                "message": "A obra em sua vida será concluída. Agradeça pela fidelidade do Artífice. O que foi iniciado será levado à perfeição."
            },
            {
                "text": "O ladrão não vem senão para roubar, matar e destruir; eu vim para que tenham vida, e a tenham em abundância.",
                "reference": "João 10:10",
                "message": "Seja grato pela promessa de vida abundante. Rejeite a destruição e abrace a plenitude que lhe foi oferecida."
            },
            {
                "text": "E não nos cansemos de fazer o bem, pois no tempo próprio colheremos, se não desanimarmos.",
                "reference": "Gálatas 6:9",
                "message": "O cansaço é real, mas não pare de fazer o bem. A colheita virá. Seja grato pela certeza da recompensa do seu trabalho."
            },
            {
                "text": "E tudo quanto pedirdes em meu nome, eu o farei, para que o Pai seja glorificado no Filho.",
                "reference": "João 14:13",
                "message": "O acesso ao Criador é um presente. Seja grato pela Sua promessa de resposta. Peça com fé e veja a glória manifestada."
            },
            {
                "text": "Nisto está o amor: não em que nós tenhamos amado a Deus, mas em que ele nos amou a nós e enviou seu Filho para propiciação pelos nossos pecados.",
                "reference": "1 João 4:10",
                "message": "O amor é uma iniciativa d'Ele. A gratidão surge desse ato sacrificial. Você foi amado primeiro e incondicionalmente."
            },
            {
                "text": "O qual nos consolou em toda a nossa tribulação, para que também possamos consolar os que estiverem em alguma tribulação, com a consolação com que nós mesmos somos consolados de Deus.",
                "reference": "2 Coríntios 1:4",
                "message": "Você foi consolado para ser um consolador. Seja grato pela sua experiência. Use a paz que recebeu para ajudar outros."
            },
            {
                "text": "Mas o que se gloria, glorie-se nisto: em me entender e me conhecer, que eu sou o Senhor, que faço beneficência, juízo e justiça na terra; porque destas coisas me agrado, diz o Senhor.",
                "reference": "Jeremias 9:24",
                "message": "Seu verdadeiro orgulho está no conhecimento d'Ele. Agradeça por Ele ser bondade, justiça e retidão em sua vida."
            },
            {
                "text": "Louvai ao Senhor. Rendei graças ao Senhor, porque ele é bom; porque a sua benignidade dura para sempre.",
                "reference": "Salmos 106:1",
                "message": "A bondade d'Ele é constante e inesgotável. Seja grato pela Sua misericórdia eterna. Louve-O com todo o seu ser."
            },
            {
                "text": "Não que sejamos capazes por nós mesmos de pensar alguma coisa, como de nós mesmos; mas a nossa capacidade vem de Deus.",
                "reference": "2 Coríntios 3:5",
                "message": "Sua capacidade não é sua, mas um dom. Seja grato pela força e habilidade que Ele lhe concede. Você é suficiente Nele."
            },
            {
                "text": "E, quanto fizerdes por palavras ou por obras, fazei tudo em nome do Senhor Jesus, dando por ele graças a Deus Pai.",
                "reference": "Colossenses 3:17",
                "message": "Cada ação e palavra é uma oportunidade de agradecer. Viva com um coração cheio de gratidão. Sua vida é um louvor."
            },
            {
                "text": "O caminho do preguiçoso é como um sebe de espinhos, mas a vereda dos justos é plana.",
                "reference": "Provérbios 15:19",
                "message": "Seja grato pela disciplina. A preguiça cria obstáculos. A retidão facilita o caminho. Escolha a diligência."
            },
            {
                "text": "Mas, de fato, Cristo ressuscitou dentre os mortos, e foi feito as primícias dos que dormem.",
                "reference": "1 Coríntios 15:20",
                "message": "O maior motivo de gratidão é a vitória sobre a morte. Sua esperança é real e a promessa de ressurreição é certa."
            },
            {
                "text": "O que confia no Senhor, a misericórdia o cercará.",
                "reference": "Salmos 32:10",
                "message": "Sua confiança atrai misericórdia. Olhe ao redor e veja-se cercado de bondade. Agradeça por essa proteção constante."
            },
            {
                "text": "Aquele que leva a preciosa semente, andando e chorando, voltará sem dúvida com alegria, trazendo consigo os seus molhos.",
                "reference": "Salmos 126:6",
                "message": "O esforço em lágrimas será recompensado com alegria. Seja grato pela promessa da colheita abundante."
            },
            {
                "text": "Se vós permanecerdes em mim, e as minhas palavras permanecerem em vós, pedireis o que quiserdes, e vos será feito.",
                "reference": "João 15:7",
                "message": "A permanência traz poder. Seja grato por ter acesso e influência. Sua oração será respondida quando você estiver conectado."
            },
            {
                "text": "O coração do homem planeja o seu caminho, mas o Senhor lhe dirige os passos.",
                "reference": "Provérbios 16:9",
                "message": "Seus planos são importantes, mas a direção é guiada. Seja grato pela orientação que o protege de desvios."
            },
            {
                "text": "Mas, se andarmos na luz, como ele na luz está, temos comunhão uns com os outros, e o sangue de Jesus Cristo, seu Filho, nos purifica de todo o pecado.",
                "reference": "1 João 1:7",
                "message": "A gratidão pela purificação é o seu louvor. A comunhão com outros é um presente dessa luz."
            },
            {
                "text": "Aquele que não poupou a seu próprio Filho, antes o entregou por todos nós, como nos não dará também com ele todas as coisas?",
                "reference": "Romanos 8:32",
                "message": "Se o maior presente foi dado, o resto é certo. Confie na generosidade d'Ele. A gratidão abre portas para mais bênçãos."
            }
        ]
    }
};

export default verses;